<template>
  <!-- Contact Section start -->
  <main id="contact-us" style="background-color: #274c8e">
    <div class="bg-canvas">
      <div class="bg-gradient">
        <section id="contact-us-section">
          <CardJumboTron>
            <h1
              class="text-white text-title my-4"
              style="
                line-height: 100%;
                text-transform: capitalize;
                font-weight: 600;
                font-size: 48px;
              "
            >
              Hubungi <span class="text-orange">Kami</span>
            </h1>

            <p
              class="text-white text-sub-title"
              style="font-size: 32px; font-weight: 600"
            >
              Efunding
              <i class="text-orange" style="font-size: 18px; font-weight: 600"
                >The First Sharia Aggregator</i
              >
            </p>

            <a 
              href="https://maps.app.goo.gl/UALqus1agreFJ99g7" 
              target="_blank" 
              rel="noopener noreferrer"
              class="d-flex align-items-center text-decoration-none"
              style="cursor: pointer;"
            >
              <img
                :src="MapOrangeIcon"
                alt="map-icon"
                style="height: 20; width: auto"
              />
              <p class="text-orange m-0 map-link">Efunding Teknologi Keuangan</p>
            </a>

            <div class="row">
              <div class="col">
                <h5
                  class="text-white mb-1"
                  style="text-transform: capitalize; font-size: 18px"
                >
                  PT Efunding Teknologi Keuangan
                </h5>

                <p class="mb-0" style="color: #b3b3b3">
                  Ruby Commercial TB21
                </p>
                <p class="mb-2" style="color: #b3b3b3">Summarecon Bekasi</p>

                <p class="mb-0" style="color: #b3b3b3">
                  Jalan Bulevar Selatan - RT.003/RW.005
                </p>
                <p class="mb-0" style="color: #b3b3b3">
                  Kelurahan Marga Mulya
                </p>
                <p class="mb-0" style="color: #b3b3b3">
                  Kecamatan Bekasi Utara
                </p>
                <p class="mb-0" style="color: #b3b3b3">
                  Kota Bekasi - Jawa Barat 17143
                </p>
              </div>
            </div>

            <div class="row align-items-center mb-2 mt-3">
              <!-- Telepon -->
              <div class="col-12 col-md-auto mb-2 mb-md-0 d-flex">
                <img
                  :src="PhoneIcon"
                  alt="map-icon"
                  style="height: 20; width: auto"
                  class="mr-2"
                />
                <p class="mb-0 text-orange">+62 818-227-070</p>
              </div>

              <!-- Email -->
              <div class="col-12 col-md-auto d-flex">
                <img
                  :src="EnvelopeIcon"
                  alt="map-icon"
                  style="height: 20; width: auto"
                  class="mr-2"
                />
                <p class="mb-0 text-orange">support@efunding.id</p>
              </div>
            </div>

            <!-- Jam Operasional -->
            <div class="row">
              <div class="col-12">
                <p class="mb-0" style="color: #b3b3b3">
                  Senin - Jumat &nbsp; | &nbsp; 09:00 - 17:00 (WIB)
                </p>
                <p class="mb-0" style="color: #F7BD3A;"><em>*Kecuali Hari Libur</em></p>
              </div>
            </div>
          </CardJumboTron>
        </section>

        <section id="contact-us-section">
          <CardPengaduan />
        </section>
      </div>
    </div>

    <CardGetStarted />

    <NewFooterClient />
  </main>
</template>
<script>
// Assets
import ContactUsBg from "../assets/images/landing_page/img-bg-contact-us.png";
import MapOrangeIcon from "../assets/images/landing_page/ic-map-orange.svg";
import EnvelopeIcon from "../assets/images/landing_page/ic-envelope.svg";
import PhoneIcon from "../assets/images/landing_page/ic-phone.svg";

// Components
import NewFooterClient from "./landing-page/newFooterClient.vue";
import CardJumboTron from "../components/landing-page/cardJumbotron.vue";
import CardGetStarted from "@/components/landing-page/cardGetStarted.vue";
import CardPengaduan from "../components/landing-page/cardPengaduan.vue";

export default {
  name: "Contact_us",
  components: { NewFooterClient, CardJumboTron, CardGetStarted, CardPengaduan },
  data() {
    return {
      ContactUsBg,
      MapOrangeIcon,
      EnvelopeIcon,
      PhoneIcon,
    };
  },
};
</script>

<style scoped>
.bg-canvas {
  background-image: url("../assets/images/landing_page/img-bg-canvas.png");
}
.bg-gradient {
  background: linear-gradient(
    to top,
    rgba(39, 76, 142, 1) 49%,
    rgba(39, 76, 142, 0)
  );
}
.map-link {
  transition: all 0.3s ease;
}
.map-link:hover {
  text-decoration: underline;
  opacity: 0.85;
}
</style>



// WEBPACK FOOTER //
// src/components/contact_us.vue